import React from "react";

const HelpDetail = () => {
  return (
                 <div className='review'>
                 <p className="bold-white-text">Help and information</p>
                  <small className="bold-grey-text pointer">Help & FAQs</small>
                  <small className="bold-grey-text pointer">Track Order</small>
                  <small className="bold-grey-text pointer">shipping & Delivery</small>
                  <small className="bold-grey-text pointer">Delivery & Returns</small>
                  </div>             
  )
}

export default HelpDetail;